import { Dropdown } from 'primereact/dropdown';

import './Styles.scss';

export default function DropDownRegularInput(props) {
    const {
        onChange,
        options,
        value
    } = props;

    return (
        <div className='input-container input-field-regular'>
            <div className={'input-field-wrapper'}>

                <Dropdown
                    value={value}
                    onChange={(e) => onChange(e.value)}
                    options={options}
                    placeholder="Seleccione"
                    className="input-field"
                />

            </div>
        </div>
    )
}